import * as React from 'react';

/**
 * Implementation of the react 18 `useId` hook. Probably not correct.
 */

let uuid = 0;

export function useId( id?: string ) {
  // Inner id for accessibility usage. Only work in client side
  const [innerId, setInnerId] = React.useState<string>( 'ssr-id' );

  React.useEffect( () => {
    const nextId = uuid;
    uuid += 1;

    setInnerId( `rc_unique_${nextId}` );
  }, [] );

  // Developer passed id is single source of truth
  if ( id ) {
    return id;
  }

  // Test env always return mock id
  if ( process.env.NODE_ENV === 'test' ) {
    return 'test-id';
  }

  // Return react native id or inner id
  return innerId;
}
